module.exports = __webpack_public_path__ + "img/O.d519cb37.png";